import {
  getEntityDomain,
  splitTranslationKey,
} from '@rydershare/shared/terminology/helpers'
import {
  PURCHASE_ORDER_PREFIX,
  PURCHASE_ORDER_SHIPMENTS_TAB_PREFIX,
  SHIPMENT_DOMAIN_PREFIX,
  SHIPMENTS_PREFIX,
  SHIPMENTS_TAB_PREFIX,
} from '@rydershare/shared/terminology/constants'

import type { i18n as I18nInstance } from 'i18next'

type ExistsOptions = { ns: string; lng: string | undefined }

const SGWS_PREFIX_REWRITES = [
  { from: SHIPMENTS_PREFIX, to: PURCHASE_ORDER_PREFIX },
  { from: SHIPMENTS_TAB_PREFIX, to: PURCHASE_ORDER_SHIPMENTS_TAB_PREFIX },
  { from: SHIPMENT_DOMAIN_PREFIX, to: PURCHASE_ORDER_PREFIX },
] as const

const translationKeyExists = (
  i18n: I18nInstance,
  keyPath: string,
  existsOptions: ExistsOptions
): boolean =>
  i18n.exists(keyPath, existsOptions) || i18n.exists(`${keyPath}_one`, existsOptions)

const formatResolvedKey = (
  namespace: string,
  keyPath: string,
  hasNamespacePrefix: boolean
) => (hasNamespacePrefix ? `${namespace}:${keyPath}` : keyPath)

export const resolveShipmentTranslationKey = (
  key: string,
  customerName: string | null | undefined,
  i18n: I18nInstance,
  defaultNamespace: string | ReadonlyArray<string> = 'common'
): string => {
  if (getEntityDomain(customerName) !== 'purchaseOrder') {
    return key
  }

  const { namespace, keyPath } = splitTranslationKey(key, defaultNamespace)
  const existsOptions: ExistsOptions = {
    ns: namespace,
    lng: i18n.resolvedLanguage,
  }
  const hasNamespacePrefix = key.includes(':')

  for (const { from, to } of SGWS_PREFIX_REWRITES) {
    if (!keyPath.startsWith(from)) {
      continue
    }

    const purchaseOrderPath = to + keyPath.slice(from.length)

    if (translationKeyExists(i18n, purchaseOrderPath, existsOptions)) {
      return formatResolvedKey(namespace, purchaseOrderPath, hasNamespacePrefix)
    }

    if (translationKeyExists(i18n, keyPath, existsOptions)) {
      return formatResolvedKey(namespace, keyPath, hasNamespacePrefix)
    }

    return key
  }

  return key
}
